"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SvgMessageWarning = function SvgMessageWarning(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", null, '.message_warning_svg__cls-2{fill:#333}')), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4 16h14.8l1.2 1.2V4H4zm2-9h12v2H6zm0 4h12v2H6z",
    fill: "#ffc414"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 2H4a2 2 0 00-2 2v12a2 2 0 002 2h14l4 4V4a2 2 0 00-2-2zm0 15.2L18.8 16H4V4h16z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6 11h12v2H6zM6 7h12v2H6z"
  }));
};

var _default = SvgMessageWarning;
exports["default"] = _default;